import { render, staticRenderFns } from "./BaseFormInput.vue?vue&type=template&id=2fcf1b15&scoped=true&"
import script from "./BaseFormInput.vue?vue&type=script&lang=js&"
export * from "./BaseFormInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormInput.vue?vue&type=style&index=0&id=2fcf1b15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcf1b15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fcf1b15')) {
      api.createRecord('2fcf1b15', component.options)
    } else {
      api.reload('2fcf1b15', component.options)
    }
    module.hot.accept("./BaseFormInput.vue?vue&type=template&id=2fcf1b15&scoped=true&", function () {
      api.rerender('2fcf1b15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseFormInput.vue"
export default component.exports